import { STATUS_BADGE_CLASSES, STATUS_LABELS } from "../lib/collaborators";
import { Archive } from "lucide-react";
import { avatarColorClass, getInitials } from "../lib/avatar";

export function StatusBadge({ status, archived, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span
        data-testid="status-badge"
        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_BADGE_CLASSES[status] || "bg-slate-100 text-slate-700"}`}
      >
        {STATUS_LABELS[status] || status}
      </span>
      {archived && (
        <span data-testid="archived-badge" className="inline-flex items-center gap-1 rounded-full bg-slate-100 text-slate-500 px-2 py-0.5 text-xs">
          <Archive size={11} /> Archivée
        </span>
      )}
    </span>
  );
}

export function Initials({ name, seed, className = "" }) {
  return (
    <span className={`inline-flex items-center justify-center rounded-full font-semibold text-xs w-8 h-8 shrink-0 ${avatarColorClass(seed || name)} ${className}`} aria-hidden="true">
      {getInitials(name)}
    </span>
  );
}

export function StatePill({ active, activeLabel = "Actif", inactiveLabel = "Inactif" }) {
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${active ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`} data-testid="state-pill">
      {active ? activeLabel : inactiveLabel}
    </span>
  );
}
